export default __webpack_public_path__ + "static/media/King Conan's Esteem.3dec0e87.jpg";